import { create } from "zustand";

import createOrderSlice from "./orderSlice";
import createFormSlice from './formSlice';
import createNavSlice from './navSlice';
import createOrderFormSlice from './orderFormSlice';

const useGlobalStore = create()((...a) => ({
  ...createOrderSlice(...a),
  ...createFormSlice(...a),
  ...createNavSlice(...a),
  ...createOrderFormSlice(...a),
}));

export default useGlobalStore;
